<script lang="ts">
  import CategorySection from './CategorySection.svelte'
  import filters from '../lib/stores/filters'
  import useFilter from '../hooks/use-filter'
  import Category from './Category.svelte'
  import Select from './Select.svelte'
  import Label from './Label.svelte'

  const { resetPriceCategory } = filters
  const { categories } = useFilter()
  const { id, season, priceTo, priceFrom, label } = categories.price
</script>

<Category {id} on:reset={resetPriceCategory}>
  <CategorySection>
    <Label class="block pb-4" as="div">
      {label}
    </Label>
    <div class="flex flex-col gap-2 sm:flex-row sm:justify-center sm:gap-6">
      {#if season}
        <Select
          id={season.id}
          name={season.name}
          label={season.label}
          options={season.options}
          bind:value={$filters[season.id]}
        />
      {/if}
      <Select
        id={priceFrom.id}
        name={priceFrom.name}
        label={priceFrom.label}
        options={priceFrom.options}
        bind:value={$filters[priceFrom.id]}
      />
      <Select
        id={priceTo.id}
        name={priceTo.name}
        label={priceTo.label}
        options={priceTo.options}
        bind:value={$filters[priceTo.id]}
      />
    </div>
  </CategorySection>
</Category>
